module.exports = __webpack_public_path__ + "img/PTR_heroimage.d1e62e03.png";